/**
 * @Author: aric 1290657123@qq.com
 * @Date: 2024-12-23 13:51:22
 * @LastEditors: aric 1290657123@qq.com
 * @LastEditTime: 2024-12-23 17:12:12
 */
import { alo7Nav } from 'common/alo7Nav';

export interface SignOptions {
  uploadType: string;
  suffix: string;
  multipartQuantity: number;
}

export interface UploadOptions {
  uploadType: string;
  suffix: string;
  eTags: string[];
  uuid: string;
  name: string;
  sizeInByte: number;
  sha256: string;
}

export interface UploadResponse {
  uuid: string;
  url: string;
}

export interface CreateSignResponse {
  uuid: string;
  accessUrl: string;
  uploadUrls: string[];
}

function createSigns(options: SignOptions) {
  return nx.$api.generate_upload_presigned({
    subject: alo7Nav.subject,
    body: options,
  }) as Promise<CreateSignResponse>;
}

function completeUpload(options: UploadOptions) {
  return nx.$api.complete_upload({
    subject: alo7Nav.subject,
    body: options,
  }) as Promise<UploadResponse>;
}

function getExtension(filename: string) {
  const lastDotIndex = filename.lastIndexOf('.');
  return lastDotIndex > 0 ? filename.substring(lastDotIndex + 1) : '';
}

export { createSigns, completeUpload, getExtension };
